import { gsap } from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

function init() {

  const dividers = document.querySelectorAll('.animate-divider')

  if(!dividers) return false


  dividers.forEach(divider => {
    ScrollTrigger.create({
      trigger: divider,
      start: 'top center',
      end: 'bottom center',
      once: true,
      onEnter: () => {
        gsap.to(divider, { width: '100%', duration: 1 })
      }
    })
  })

}

init()
